import { Column, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity("production_workers")

export class ProductionWorkersEntity {

    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    @Column('int',{
        name:'emp_id'
    })
    empId : number

    @Column('varchar',{
        name:'emp_code',
        length :50
    })
    empCode : string

    @Column('varchar',{
        name:'emp_name',
        length :100
    })
    empName : string

    @Column('int',{
        name:'contractor_id'
    })
    contractorId : number

    @Column('varchar',{
        name:'contractor_name',
        length :100
    })
    contractorName : string

    @Column('varchar',{
        name:'village',
        length :100
    })
    village : string

    @Column('int',{
        name:'production_log_id'
    })
    productionLogId : number

    @Column('varchar',{
        name:'operation',
        length : 20,
        nullable:false
    })
    operation : string

    @Column('varchar',{
        name:'transportation',
        length : 20,
        nullable:false
    })
    transportation : string

    @Column('varchar',{
        name:'bill_no',
        length: 30,
        nullable:false
    })
    billNo : string

    @Column('decimal',{
        name:'transport_charges',
        nullable:true,
        precision:10,scale:3,
        unsigned:true,
    })
    transportCharges : number

    @Column('decimal',{
        name:'avg_qty',
        nullable:true,
        precision:10,scale:3,
        unsigned:true,
    })
    avgQty : number

    @Column('decimal',{
        name:'avg_wage',
        nullable:true,
        precision:10,scale:3,
        unsigned:true,
    })
    avgWage : number

}